export default function formatHiddenRollValue(value) {
  const numericValue = Number(value)

  if (Number.isFinite(numericValue)) {
    const normalizedValue = Math.min(Math.max(Math.trunc(numericValue), 1), 100)
    return normalizedValue === 100 ? '00' : String(normalizedValue).padStart(2, '0')
  }

  const stringValue = String(value ?? '').trim()

  if (stringValue === '100') {
    return '00'
  }

  return stringValue.padStart(2, '0')
}
